import React, {Component} from "react";
import UserLinkHeader from "./UserLinkHeader";
import TakemoneyItems from "./Takemoney/TakemoneyItems";
import Xhr from "../../helpers/Xhr";
import Loading from "../../components/Loading";
import {LOCAL} from "../../constants/local";

class UserPay extends Component {

	state = {
		amount   : 0,
		messages : '',
		fetching : false,
		error    : false,
	};

	changeAmount(e) {
		const amount = e.target.value;
		const messages = [];
		let error = false;
		if ( +amount < 2 || amount === '' ) {
			messages.push(`Минимальная сумма пополнения - 2 ${LOCAL.currency}!`);
			error = true;
		}
		else {
			messages.splice(0, messages.length);
			error = false;
		}

		this.setState({
			error    : error,
			messages : messages,
			amount   : e.target.value
		});
	}

	onSubmit(event) {
		event.preventDefault();
		if (this.state.error) {
			return;
		}

		this.setState({fetching : !this.state.fetching});
		Xhr.cashIn(this.state.amount).then((resp) => {
			if ( resp.status === 'ok' && resp.hasOwnProperty('data') ) {
				return document.location.href = resp.data.link;
			}

			this.setState({
				messages : resp && resp.messages || '',
				fetching : false
			});
		});
	}

	render() {
		const img = require('./../../../assets/images/visa-mastercard.png');
		return (
			<div className="news">
				<UserLinkHeader/>

				<div className="table cash-in-out__table">
					<div className="table__row header">
						<div className="table__column cash-in-type">Способ пополнения</div>
						<div className="table__column cash-in-amount">&nbsp;</div>
						<div className="table__column cash-in-actions">&nbsp;</div>
					</div>

					<div className="table__row subheader">
						<div className="table__column cash-in-type">Пополнить счет</div>
						<div className="table__column cash-in-amount"></div>
						<div className="table__column cash-in-actions"></div>
					</div>

					<div className="description__order">
						<div className="table__row data">
							<div className="table__column payment-type">
								<i className="fas fa-map-marker-alt"></i>
								<span>Пункты приема ставок</span>
							</div>
						</div>

						{/*<form action="http://maxline.by/payment/pay-in-by-3d" method="post" onSubmit={this.onSubmit.bind(this)}>*/}
							{/*<div className="table__row data">*/}
								{/*<div className="table__column cash-in-type">*/}
									{/*<img src={img} alt=""/>*/}
									{/*<span>Visa/MasterCard</span>*/}
									{/*{this.state.fetching && <Loading style={{margin : "0 10px"}}/>}*/}
								{/*</div>*/}
								{/*<div className="table__column cash-in-amount">*/}
									{/*<input type="text" name="XML" value={this.state.amount} onChange={this.changeAmount.bind(this)}/>*/}
								{/*</div>*/}
								{/*<div className="table__column cash-in-actions">*/}
									{/*<div className="buttons">*/}
										{/*<button className="buttons__show">Пополнить</button>*/}
									{/*</div>*/}
								{/*</div>*/}
							{/*</div>*/}
						{/*</form>*/}
					</div>

					{this.state.messages.length > 0 &&
					<div className="description__order-item" style={{margin : "0 auto"}}>
						<i className="warning">
							{this.state.messages}
						</i>
					</div>}
				</div>
			</div>
		);
	}
}

export default UserPay;


// WEBPACK FOOTER //
// ./src/app/pages/User/UserPay.js